export const sendTrackingEvent = (eventObj: { [key: string]: string }) => {
	if (window && (window as any).dataLayer && (window as any).dataLayer.push) {
		(window as any).dataLayer.push(eventObj);
	}
};
